// @flow

import React,{ useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';

import { log, capitalizeFirstLetter } from '../../utils/jsUtils';
import { useI18n } from '../../contexts/I18nContext';
import RemovableModalImage from '../SharedComponents/RemovableModalImage';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import SmsFailedIcon from '@mui/icons-material/SmsFailed';

import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/TaskV2Activity.Style';

type Props = {
  history: Array<Object>,
  task: Object,
  tenant: Object
};

const TaskV2Activity = (props: Props) => {
  const {
    history,
    tenant
  } = props;
  
  const theme = useTheme();
  const classes = createClasses(styles, theme);
  const i18n = useI18n();

  const [openActiveZoom, setOpenActiveZoom] = useState(false);
  const [activeZoomUrl, setActiveZoomUrl] = useState('');

  const handleOpenZoomAttachment = (attachmentUrl: string) => () => {
    setActiveZoomUrl(attachmentUrl);
    setOpenActiveZoom(true);
  };
  const handleCloseZoomAttachment = () => {
    setOpenActiveZoom(false);
    setActiveZoomUrl('');
  };

  // eslint-disable-next-line react/no-multi-comp
  const AttachmentZoomDialog = (props: {
    open: boolean,
    activeZoomUrl: string,
    onClose: Function
  }) => {
    const {
      open,
      activeZoomUrl,
      onClose
    } = props;

    return (
      <Dialog aria-labelledby="attachment-zoom"
        sx={classes.attachmentImgZoomPaper}
        onClose={() => onClose()}
        open={open}
      >
        <IconButton
          aria-label="Close"
          sx={classes.zoomCloseBtn}
          color="inherit"
          key="close"
          onClick={onClose}
        >
          <CloseIcon sx={classes.closeIcon} />
        </IconButton>
        <img style={classes.attachmentImgZoom}
          src={activeZoomUrl}
        />
      </Dialog>
    );
  };
  
  return (
    <>
    {/* {
      tenant
      ? <Typography variant='h6'>
        {
          tenant.FirstName === 'Guest'
          ? <div className={classes.senderName}>
              <b>
              {`${tenant.FirstName} (${formatPhoneNumberForFrontend(tenant.Phone)})`}
              </b>
            </div>
          : <b>
            {`${tenant.FirstName} ${tenant.LastName}`}
            </b>
        }
        </Typography>
      : null
    } */}
    {
      tenant
      ? <div style={classes.messageThread}>
          {
            history
            ? history.map((entry, entryIdx) => (
              <div key={entryIdx}>
              {
                entry.type === 'unread'
                ? <div style={classes.newMsgIndicatorCtr}>
                  <Typography
                    sx={classes.newMsgIndicator}
                    variant='body1'
                  >{'NEW'}</Typography>
                  </div>
                : null
              }
              
              {
                entry.type === 'message'
                ? <Box
                    sx={{
                      ...classes.messageLineCtr,
                      ...(entry.SenderPersona === 'customer'
                        ? classes.messageLineCtrCustomer
                        : classes.messageLineCtrSupport)
                    }}
                    key={`history-${entryIdx}`}
                  >
                    <div style={classes.messageCaptionCtr}>
                      <Typography
                        sx={classes.msgCaption}
                        component='p'
                        variant='body1'
                      >
                        {
                          entry.SenderUserFullName && !entry.SenderUserFullName.startsWith('undefined')
                          ? `${entry.SenderUserFullName.trim()}, `
                          : `${capitalizeFirstLetter(entry.SenderPersona)}, `
                        }
                        {
                          moment().diff(entry.CreatedDt, 'days') > 7
                          ? moment(entry.CreatedDt).format('L')
                          : moment(entry.CreatedDt).from(moment())
                        }
                      </Typography>
                      <div style={classes.deliveryIconCtr}>
                      {
                        entry.SMSStatus
                        ? entry.SMSStatus.MessageStatus === 'delivered'
                          ? <Tooltip title={'Message delivered'}>
                              <DoneIcon sx={classes.deliveryIconDelivered}/>
                            </Tooltip>
                          : entry.SMSStatus.MessageStatus === 'undelivered'
                            || entry.SMSStatus.MessageStatus === 'failed'
                            ? <Tooltip title={'Message delivery failed'}>
                                <SmsFailedIcon sx={classes.deliveryIconFailed}/>
                              </Tooltip>
                            : entry.SMSStatus.MessageStatus === 'error'
                              ? <Tooltip title={entry.SMSStatus.ErrorMessage}>
                                <SmsFailedIcon sx={classes.deliveryIconFailed} />
                              </Tooltip>
                              : <Tooltip title={'Sending...'}>
                                <DoneIcon sx={classes.deliveryIconSending} />
                              </Tooltip>
                        : null
                      }
                      </div>
                    </div>

                    {
                      entry && entry.Attachments && entry.Attachments.length > 0
                      ? <Box sx={classes.attachmentRowCtr}>
                        {
                          entry.Attachments.map((attachment, attIndex) => {
                            return (
                              <RemovableModalImage
                                key={`img-${entry._id}-${attIndex}`}
                                src={attachment.Url}
                                isRemovable={false}
                                onRemove={() => {}}
                              />
                            );
                          })
                        }
                        </Box>
                      : null
                    }
                    {entry.Message && entry.Message.trim() !== '' && (
                      <Paper
                        sx={{
                          ...classes.messageCtr,
                          ...(entry.SenderPersona === 'customer' ? classes.customerMsg : classes.supportMsg)
                        }}
                      >
                        <Typography
                          sx={classes.messageContent}
                          component='p'
                          variant='h6'
                        >
                          {entry.Message}
                        </Typography>
                      </Paper>
                    )}
                  </Box>
                : null
              }
              {
                entry.type === 'log'
                ? <Paper
                    sx={classes.logCtr}
                    key={`history-${entryIdx}`}
                  >
                    {/* <Typography variant="h6" component="h1">
                      {entry.Message}
                    </Typography> */}
                    <Typography>
                      {`${entry.Comment} `}  
                      {
                        moment().diff(entry.CreatedDt, 'days') > 30
                        ? moment(entry.CreatedDt).format('L')
                        : moment(entry.CreatedDt).from(moment())
                      }
                    </Typography>
                  </Paper>
                : null
              }
              </div> 
              ))
            : null
          }
        </div>
      : <Typography style={{transform: 'rotate(180deg)'}}
          variant='h6'
        >
        <b>
          {`${i18n.t('Tenant')} has been removed.`}
        </b>
      </Typography>
    }
    <AttachmentZoomDialog
      activeZoomUrl={activeZoomUrl}
      onClose={handleCloseZoomAttachment}
      open={openActiveZoom}
    />
    </>
  );
};

export default TaskV2Activity;